import React, { useEffect, useLayoutEffect, useState } from 'react'
import { HiChevronDown } from 'react-icons/hi2'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { GrChapterNext, GrChapterPrevious } from "react-icons/gr";


// import { getRequest } from '../../../api/Request'
// import { UserList } from './UserList'
// import { ReactComponent as CircularLoader } from '../assets/svg/CircularLoader.svg'
import { getRequest } from '../api/api';
import Table from '../components/Table/Table';

const Accounts = () => {
    const [showfilter, setShowfilter] = useState(false)
    const [isloading, setIsloading] = useState(true)
    const [userList, setuserList] = useState([])

    const location = useLocation()
    const navigate = useNavigate()
   

    useEffect(() => {
      fetch_users()
    }, [])


    const fetch_users = async () => {
        setIsloading(true)
        let response = await getRequest('/auth/users/')
        console.log(response);
        
        if(response.status === 200) {
            setuserList(response.data)
            // saveData(response.data)
        }
        setIsloading(false)
    }
    

   
    const filter = (filter_param) => {

    }

    const columns = [
        {
          key: "fullName",
          header: "Full Name",
          cell: (user) => `${user?.first_name} ${user?.last_name}`,
        },
        {
          key: "email",
          header: "User email",
          cell: (user) => user?.email,
        },
        {
          key: "phone",
          header: "Phone Number",
          cell: (user) => user?.phone,
        },
        {
          key: "company",
          header: "Company",
          cell: (user) => user?.company || "None",
        },
        {
            key: "lastActivity",
            header: "Last Activity",
            cell: (user) => user?.last_login ? new Date(user.last_login).toLocaleString() : "None",
        },
        {
            key: "address",
            header: "Address",
            cell: (user) => user?.address_one || "None",
        },
        {
            key: "nationality",
            header: "Nationality",
            cell: (user) => user.country || "None",
        },
    ]

  return (
    <>
        <nav className='navbar nav_adders'>
            <div className='nav_left'>
                <Link to ='' className='nav_link route_path'>Accounts</Link>
                <Link to='' className='nav_link'>#code</Link>
            </div>
            <div className='nav_right nav_filters'>
                <Link to ='' className='nav_link filter'>Today</Link> 
                <Link to ='' className='nav_link filter'>This week</Link> 
                <Link to ='' className='nav_link filter'>This Month</Link> 
            </div>
        </nav>

        <section className='filter_actions'>
            <div className='filter_by_dropdown'>
                <span className='filter_by' onClick={() => setShowfilter(!showfilter)}>Filter by <span className='icon'> <HiChevronDown /></span></span>
                {
                    showfilter && (
                    <div className='filter_by_dropdown_content'>
                        <p onClick={() => filter('active')} >active</p>
                        <p onClick={() => filter('waiting')} >waiting review</p>
                        <p onClick={() => filter('invisibile')} >Blocked accounts</p>
                        <p onClick={() => filter('deleted')} >recently deleted</p>
                    </div>
                    )
                }
            </div>
            <div className='search_filter'>
                <input type='text' placeholder='search...' />
            </div>
        </section>

        <Table
            data={userList}
            columns={columns}
            keyExtractor={(user) => user.email}
            isLoading={isloading}
            onRowClick={(user) => navigate('/user/' + user?.first_name)}
            emptyState={<div className="text-center p-4">No Data Found</div>}
        />
        {
            !isloading && (
            <div className='list_controller'>
                <div className='prev_list list_control_btn'>
                <GrChapterPrevious />
                </div>
                <p>30 / 500</p>
                <div className='next_list list_control_btn'>
                    <GrChapterNext />
                </div>
            </div>
            )
        }
    </>
  )
}

export default Accounts